import styled from "styled-components";
import ValidationText from "./ValidationText";

const StyledValidationText = styled(ValidationText)`
  color: red;
  margin: 0;
  padding: 0;
  font-size: 1.2rem;
  /* height: 0; */
`;

export default StyledValidationText;
